import type { AnalyticsObject, AnalyticsProperties } from '../types'

export class AppPrompt implements AnalyticsObject {
  name: string
  properties: AppPromptProperties
  constructor(properties: AppPromptProperties) {
    this.name = 'App Prompt'
    this.properties = properties
  }
}

export interface AppPromptProperties extends AnalyticsProperties {
  prompt_type: PromptType
  vertical?: string
}

export type PromptType =
  | 'HeroSearchForm_Home'
  | 'AboveHeroSearchForm_Home'
  | 'HeroSearchForm_IMT'
  | 'AboveHeroSearchForm_IMT'
  | 'HeroSearchForm_Country'
  | 'AboveHeroSearchForm_Country'
  | 'minimal'
  | 'post_clickout'
  | 'header_button'
  | 'hide_promos_send'
  | 'hide_promos_save'
  | 'hide_promos_providers'
  | 'hide_promos_generic'
  | 'tooltip'
  | 'warning'
  | 'no_results'
